import { KEYCLOAK_HOST, ORIG_ENV_QUERY_NAME } from './environment'
import Keycloak from 'keycloak-js'

export const keycloak = new Keycloak({
  url: KEYCLOAK_HOST,
  realm: 'TomraConnectUsers',
  clientId: 'promotion-ui',
})

export function getRedirectUrl(): string {
  const url = new URL(window.location.href)
  const params = new URLSearchParams()
  for (const name of [ORIG_ENV_QUERY_NAME, 'licenseAccount']) {
    const value = url.searchParams.get(name)
    if (value !== null) {
      params.set(name, value)
    }
  }
  url.search = params.toString()
  url.hash = ''
  return url.href
}
